// extracted by mini-css-extract-plugin
module.exports = {"table":"TopFlopTableKpi_table__2lBYZ"};